import React from 'react';
import PropTypes from 'prop-types';
import DataCacheService from '@/shared/services/DataCacheService';
import TaskProgressPerEmployeeCell from './TaskProgressPerEmployeeCell';

const TaskProgressPerEmployeeRow = ({ row, columns, useExecutionDuration, onCellClick }) => {
  const userName = DataCacheService.getUserName(row.userId) || row.userId;

  return (
    <tbody className="hover">
      <tr>
        <td>{userName}</td>
        {columns.map((column, idx) => (
          <TaskProgressPerEmployeeCell
            key={column.id}
            cell={row.cells[idx]}
            useExecutionDuration={useExecutionDuration}
            onClick={() => onCellClick(column, row, { notDoneOnly: false })}
            onCompletedClick={() => onCellClick(column, row, { notDoneOnly: true })}
          />
        ))}
      </tr>
    </tbody>
  );
};

TaskProgressPerEmployeeRow.propTypes = {
  row: PropTypes.shape({
    userId: PropTypes.string.isRequired,
    cells: PropTypes.arrayOf(
      PropTypes.shape({
        completedCount: PropTypes.number,
        totalCount: PropTypes.number,
        completedDurationMinutes: PropTypes.number,
        totalDurationMinutes: PropTypes.number,
        tasksWithoutExecutionDurationCount: PropTypes.number,
      }),
    ).isRequired,
  }).isRequired,
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      isMainTask: PropTypes.bool,
    }),
  ).isRequired,
  useExecutionDuration: PropTypes.bool.isRequired,
  onCellClick: PropTypes.func.isRequired,
};

export default React.memo(TaskProgressPerEmployeeRow);
